import React, {useContext} from "react";
import "./QuickInfoScore.scss";
import UniversalButton from "../uiComponents/UniversalButton";
import ChooseCategory from "../modals/ChooseCategory";
import { ModalContext } from "../ModalContext";
import { runTest } from "../../utils/builder/ITestLogic";
import { loadModelAction, resetModel } from "../../store/actions/modal";
import { useDispatch } from "react-redux";
import { getTabs } from "../../store/actions/table";
import Rating from "components/uiComponents/Ratting";


const QuickInfoScore = ({quickScore, managerQuickInfoScore}) => {

  const { handleModal } = useContext(ModalContext);
  const dispatch = useDispatch();

    const handleClick = () => {
        handleModal(<ChooseCategory loadModel={loadModel}/>);
  };

  const loadModel = () => {

    const categories = JSON.parse(localStorage.getItem("categories"));

    dispatch(resetModel());
    managerQuickInfoScore(false);

    runTest(categories.discipline, categories.stage)
      .then((res) => {
        dispatch(loadModelAction(res));
        dispatch(getTabs(res.tables));
      });
  };

  return (
      <div className="score">
        <Rating isEditable={false} initialRatting={quickScore} />
        <UniversalButton
          type="button"
          label="New check"
          size="md"
          labelColor="white"
          labelHoverColor="white"
          backgroundColor="orange"
          backgroundHoverColor="orange-light"
          isRounded="sm"
          onClick={handleClick}
        />
      </div>
  );
};

export default QuickInfoScore;
